import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7300Model } from '../kymw7300.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { CouponInfo } from '../vo/coupon-info.model';

// レスポンス構造
export type GetCouponListResponse = {
  TotalNum: string;
  StartDispNum: string;
  EndDispNum: string;
  CouponList: [
    {
      CouponGoodsNo: string;
      CouponOrderCd: string;
      CouponName: string;
      CouponIssueCatalogStart: string;
      CouponIssueCatalogEnd: string;
      CouponReceiptCatalogStart: string;
      CouponReceiptCatalogEnd: string;
      CouponCategory: string;
      CouponCategoryName: string;
      NoticeExistenceType: string;
      NoticeExistenceTypeName: string;
      NoticeMethodTypeItem: string;
      NoticeMethodTypeNameItem: string;
      NoticeMethodTypeMail: string;
      NoticeMethodTypeNameMail: string;
    }
  ];
};

/**
 * 注文単位値引クーポン一覧取得サービス
 *
 * @export GetCouponListService
 * @class GetCouponListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCouponListService extends PlessJsonResponderSub<GetCouponListResponse> {
  private model: KYMW7300Model;
  private calbak: () => void;
  private page: number;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCouponListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        CouponList: {
          condition: {
            CouponIssueCatalog: this.model.couponIssueCatalog,
            ReceiptCatalog: this.model.receiptCatalog,
            CouponOrderCd: this.model.couponOrderCd,
            CouponCategory: this.model.couponCategory,
            CouponName: this.model.couponName,
            Page: this.page,
          },
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof GetCouponListService
   */
  execute(model: KYMW7300Model, page: number, f?: () => void): void {
    this.model = model;
    this.page = page;
    this.calbak = f;
    this.send('getCouponList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof GetCouponListService
   */
  success(data: GetCouponListResponse) {
    const total = Number(data.TotalNum);
    if (!Number.isNaN(total)) this.model.totalNum = total;
    const start = Number(data.StartDispNum);
    if (!Number.isNaN(start)) this.model.startDispNum = start;
    const end = Number(data.EndDispNum);
    if (!Number.isNaN(end)) this.model.endDispNum = end;
    this.model.couponList = data.CouponList.map(
      _ => new CouponInfo(_)
    );
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 
   * 検索結果が無い場合、一覧をクリアする。
   */
  public plessErrorHandler(errList: any): void {
    super.plessErrorHandler(errList);
    // "message": "該当するデータがありません"
    if (errList.errorcode === "E0100") {
      this.clearCouponList();
    }
  }

  /**
   * 一覧表示を初期化する
   */
  public clearCouponList() {
    this.model.couponList = [];
  }
}
